module.exports = __webpack_public_path__ + "images/category_lp/common/shape-left_a15be9a21b6baea6a742c5c925f28e48.png";